import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PaymentMethodCode } from '@web/shared/module/shop';

@jsonObject
export class AdminOrderPaymentMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly code!: PaymentMethodCode;

  @jsonMember(String)
  public readonly name!: string;
}
